import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { ColumnItem } from '../../constants/dndItemTypes';
// noinspection ES6PreferShortImport "Use direct import to avoid circular dependency"
import { useSTColumn, useSTColumnOrder } from '../../table/SmartTableContext';
import { defineStyles, theme } from '../../theme';
const styles = defineStyles({
    root: {
        borderTop: `2px solid transparent`,
        borderBottom: `2px solid transparent`,
        pb: 0.25,
    },
    overRoot: {
        '&:first-of-type': {
            borderTop: `2px solid ${theme.vars.palette.secondary.main}`,
        },
        '&:not(:first-of-type)': {
            borderBottom: `2px solid ${theme.vars.palette.secondary.main}`,
        },
    },
    buttonContainer: {
        background: theme.vars.palette.background.paper,
        transition: 'all 0.35s ease',
        display: 'flex',
        alignItems: 'center',
        border: `1px solid ${theme.vars.palette.secondary.main}`,
        borderRadius: 2,
    },
    button: {
        py: 0.5,
        px: 1,
        flexGrow: 1,
        justifyContent: 'flex-start',
        '& .MuiCheckbox-root': {
            py: 0,
        },
        '& .MuiFormControlLabel-label': {
            fontSize: (theme) => theme.typography.caption,
            fontStyle: 'italic',
        },
    },
    handle: {
        cursor: 'move',
        color: theme.vars.palette.secondary.main,
    },
    dragging: {
        opacity: 0.5,
    },
});
export function ColumnsSettingsDialogRow({ column }) {
    const { isColumnVisible, toggleColumnVisibility } = useSTColumn(column);
    const { moveColumn } = useSTColumnOrder();
    const [{ isDragging }, drag] = useDrag({
        type: ColumnItem,
        item: { type: ColumnItem, fieldName: column.fieldName },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const [{ isOver }, drop] = useDrop({
        accept: ColumnItem,
        collect: (monitor) => ({
            isOver: monitor.isOver(),
        }),
        drop: (item) => {
            moveColumn(item.fieldName, column.fieldName);
        },
    });
    const ref = useRef(null);
    drag(drop(ref));
    return (_jsx(Box, { sx: { ...styles.root, ...(isOver && styles.overRoot) }, children: _jsxs(Box, { ref: ref, sx: { ...styles.buttonContainer, ...(isDragging && styles.dragging) }, children: [_jsx(Button, { variant: "text", disableRipple: true, sx: styles.button, onClick: toggleColumnVisibility, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { disableRipple: true, id: column.fieldName, ...{
                                checked: isColumnVisible,
                                name: column.fieldName,
                            } }), label: column.header || column.fieldName }) }), _jsx(DragIndicatorIcon, { sx: styles.handle })] }) }));
}
//# sourceMappingURL=ColumnsSettingsDialogRow.js.map